<h1 mat-dialog-title
    class="draggable-dialogue-header title-h"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{Title}}
</h1>

<div *ngIf="CheckingSubscriptions" class="alreadySubscribed">
    Checking your subscriptions...
</div>

<div *ngIf="!CheckingSubscriptions && isSubscribed()" class="alreadySubscribed">
    <div *ngIf="IsExactMatch">
        You are subscribed to receive form workflow notifications for this {{Entity}}.
    </div>
    <div *ngIf="IsMatchedByAncestor">
        You are subscribed to receive form workflow notifications for this {{Entity}} on account of your subscription on the following Folder: "{{SubscribedEntityPath}}"
    </div>
    <!--
        <div>IsExactMatch: {{IsExactMatch}}</div>
        <div>IsMatchedByAncestor = {{IsMatchedByAncestor}}</div>
        <div>SubscribedEntityName = {{SubscribedEntityName}}</div>
        <div>SubscribedEntityPath = {{SubscribedEntityPath}}</div>
    -->
</div>

<div class="buttons-div">
    <button *ngIf="!isSubscribed() && !CheckingSubscriptions"
            mat-flat-button
            type="submit"
            color="primary"
            class="theme-primary-btn"
            (click)="this.subscribe()">
        Subscribe
    </button>
    <!-- only display unsubscribe if IsExactMatch-->
    <button *ngIf="isSubscribed() && !CheckingSubscriptions && IsExactMatch"
            mat-flat-button
            type="submit"
            color="warn"
            class="theme-primary-btn"
            (click)="this.unsubscribe()">
        Unsubscribe
    </button>

    <button mat-flat-button
            class="basic"
            style="margin-left: 10px;"
            (click)="this.cancel()">
        Cancel
    </button>
</div>
